<template>
  <nw-form
    :nw-form-value="form"
    @nw-form-input="handleNwFormInput"
    ref="nwForm"
  >
    <b-form-group
      id="Breaths"
      :label="$t('kiosk.breath')"
      label-for="Breaths"
      label-cols="3"
    >
      <validation-provider
        :name="$t('kiosk.breath')"
        rules="required|integer"
        #default="{ errors }"
      >
        <b-input-group
          append="bpm"
          class="input-group-merge"
        >
          <b-form-input
            id="Breaths"
            :value="form.Breaths"
            @input="v => { form.Breaths = v; emitFormData() }"
          />
        </b-input-group>
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
  </nw-form>
</template>

<script>
import nwFormTaskTypeMixin from "@/views/kiosk/components/kskNursingWork/mixins/nwFormTaskTypeMixin";

export default {
  name: "NwFormBreath",
  mixins: [nwFormTaskTypeMixin],
}
</script>

<style scoped>

</style>